import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Products } from "../../models/products.models";

export const ProductsActions = createActionGroup({
    source:'products',
    events:{
        'Load Products': emptyProps(),
        'Add Products': props<{products:Products}>(),
    }
})